const STORAGE_KEY = 'duelcash-support-preview';
const TAB_KEY = 'duelcash-support-tab';

function getSupportTicket(location) {
  if (!location || location.pathname !== '/support-preview') {
    return null;
  }
  const ticket = new URLSearchParams(location.search || '').get('ticket');
  return ticket && /^[a-f0-9]{64}$/.test(ticket) ? ticket : null;
}

function takeSupportTicket(location, history, bootstrapWindow) {
  let ticket = getSupportTicket(location);
  if (bootstrapWindow) {
    const bootstrapTicket = bootstrapWindow.__duelcashSupportTicket;
    delete bootstrapWindow.__duelcashSupportTicket;
    if (typeof bootstrapTicket === 'string' && /^[a-f0-9]{64}$/.test(bootstrapTicket)) {
      ticket = bootstrapTicket;
    }
  }
  if (location && location.pathname === '/support-preview') {
    history.replaceState(history.state, '', '/support-preview');
  }
  return ticket;
}

function shouldTrackCustomerAnalytics(supportPreview) {
  return !supportPreview;
}

function saveSupportSession(storage, session) {
  if (!session || typeof session.token !== 'string' || !Number.isFinite(session.expiresAt)) {
    throw new Error('Invalid support session');
  }
  storage.setItem(TAB_KEY, '1');
  storage.setItem(STORAGE_KEY, JSON.stringify(session));
}

function readSupportSession(storage, nowSeconds = Math.floor(Date.now() / 1000)) {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    let session;
    try {
      session = JSON.parse(raw);
    } catch (error) {
      session = null;
    }
    if (session && typeof session.token === 'string' && Number.isFinite(session.expiresAt)
        && session.expiresAt > nowSeconds) {
      return { token: session.token, expiresAt: session.expiresAt };
    }
    clearSupportSession(storage);
  } catch (error) {
    // Browser storage can be unavailable; normal customer pages can still load.
  }
  return null;
}

function readSupportSessionFromWindow(windowObject, nowSeconds = Math.floor(Date.now() / 1000)) {
  try {
    return readSupportSession(windowObject.sessionStorage, nowSeconds);
  } catch (error) {
    return null;
  }
}

function hasSupportTabMarkerFromWindow(windowObject) {
  try {
    return windowObject.sessionStorage.getItem(TAB_KEY) === '1';
  } catch (error) {
    return false;
  }
}

function selectInitialAuth(windowObject, normalToken, nowSeconds = Math.floor(Date.now() / 1000)) {
  const pendingSupportTicket = windowObject.location.pathname === '/support-preview';
  let hadSupportSessionKey = false;
  try {
    hadSupportSessionKey = windowObject.sessionStorage.getItem(STORAGE_KEY) !== null;
  } catch (error) {
    // If storage is denied, ordinary customer authentication can continue.
  }
  let supportSession = readSupportSessionFromWindow(windowObject, nowSeconds);
  let supportTab = hasSupportTabMarkerFromWindow(windowObject);
  if (!pendingSupportTicket && hadSupportSessionKey && !supportTab) {
    // Sessions created by the old read-only flow have no tab marker.
    try {
      windowObject.sessionStorage.setItem(TAB_KEY, '1');
      clearSupportSession(windowObject.sessionStorage);
    } catch (error) {
      // Keep this page isolated even if tab storage changes unexpectedly.
    }
    supportSession = null;
    supportTab = true;
  }
  const supportTabEnded = !pendingSupportTicket && !supportSession
    && supportTab;
  const token = pendingSupportTicket || supportTabEnded ? ''
    : (supportSession ? supportSession.token : normalToken);
  return { token, supportSession, supportTabEnded, pendingSupportTicket };
}

function clearSupportSession(storage) {
  storage.removeItem(STORAGE_KEY);
  for (let index = storage.length - 1; index >= 0; index--) {
    const key = storage.key(index);
    if (key && key.startsWith('scoreLogPartidasSupport:')) {
      storage.removeItem(key);
    }
  }
}

function exitSupportSession(storage) {
  clearSupportSession(storage);
  storage.removeItem(TAB_KEY);
}

function supportBannerLabel(userData) {
  const user = userData && (userData.email || userData.name);
  return 'Ingresaste como ' + (user || 'usuario');
}

function completeSupportLogin(storage, session, location) {
  saveSupportSession(storage, session);
  location.replace('/');
}

async function exchangeSupportTicket(fetcher, backendUrl, ticket) {
  if (!/^[a-f0-9]{64}$/.test(ticket || '')) {
    throw new Error('Support preview unavailable');
  }
  const response = await fetcher(backendUrl.replace(/\/$/, '') + '/api/supportPreview', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'exchange', ticket }),
  });
  const result = await response.json();
  if (!response.ok || !result.success || typeof result.supportToken !== 'string'
      || !Number.isFinite(result.expiresAt)) {
    throw new Error('Support preview unavailable');
  }
  return { token: result.supportToken, expiresAt: result.expiresAt };
}

export {
  getSupportTicket,
  takeSupportTicket,
  shouldTrackCustomerAnalytics,
  saveSupportSession,
  readSupportSession,
  readSupportSessionFromWindow,
  hasSupportTabMarkerFromWindow,
  selectInitialAuth,
  clearSupportSession,
  exitSupportSession,
  supportBannerLabel,
  completeSupportLogin,
  exchangeSupportTicket,
};
